/**
 * The catch-all 404 page. Extracted from `App.tsx` unchanged (BON-472) so that
 * file declares one component — see `ProtectedRoute` for the reason.
 */
export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-bark-900 dark:text-stone-100 mb-4">404</h1>
        <p className="text-stone-600 dark:text-stone-400 mb-4">Page not found</p>
        <a href="/" className="text-moss-600 hover:text-moss-700">
          Go home
        </a>
      </div>
    </div>
  );
}
